module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SemiBoldItalic.a45bd52.woff";